import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { MarketingConsentDetailsIdentifierType } from '@wix/ambassador-marketing-marketing-consent-v1-marketing-consent/types';
import { Channel } from '@wix/ambassador-notifications-v1-notification-preferences/types';
import { membersAreaNotificationSettingsPageStartLoading } from '@wix/bi-logger-identity-data/v2';
import {
  getMarketingConsent,
  setMarketingConsent,
} from '../../apis/marketing-consent/marketing-consent';
import {
  getChannelPreferences,
  setPreference,
} from '../../apis/preferences-server/preferences-server';

export enum ActionType {
  FETCH_SUBSCRIBE = 'FETCH_SUBSCRIBE',
  FETCH_PREFERENCES = 'FETCH_PREFERENCES',
  SET_CONSENT_SUBSCRIBE = 'SET_CONSENT_SUBSCRIBE',
  SET_CONSENT_UNSUBSCRIBE = 'SET_CONSENT_UNSUBSCRIBE',
  SET_PREFERNCES = 'SET_PREFERNCES',
}

export type ActionIndicator = {
  actionType: ActionType;
  success: boolean;
  error?: string;
};
const createController: CreateControllerFn = async ({
  flowAPI,
  controllerConfig,
}) => {
  const startLoadingTime = Number(new Date());
  if (!flowAPI.environment.isSSR) {
    flowAPI.bi?.report(membersAreaNotificationSettingsPageStartLoading({}));
  }
  if (flowAPI.experiments.enabled('specs.ping.errorHandlerInUou')) {
    const [channelPreferences, { isSubscribed } = { isSubscribed: undefined }] =
      await Promise.all([
        getChannelPreferences({
          flowAPI,
          setProps: controllerConfig.setProps,
          channel: Channel.EMAIL,
        }),
        getMarketingConsent({
          flowAPI,
          setProps: controllerConfig.setProps,
          type: MarketingConsentDetailsIdentifierType.EMAIL,
        }),
      ]).catch((e) => {
        controllerConfig.setProps({
          actionIndicator: {
            actionType: ActionType.FETCH_SUBSCRIBE,
            success: false,
            error: flowAPI.errorHandler.getResolvedError(e).message,
          },
        });
        return [undefined, undefined];
      });
    if (channelPreferences && isSubscribed) {
      controllerConfig.setProps({
        actionIndicator: {
          actionType: ActionType.FETCH_SUBSCRIBE,
          success: true,
        },
      });
    }
    const onChangeSubscription = async (shouldSubscribe: boolean) =>
      setMarketingConsent({
        flowAPI,
        setProps: controllerConfig.setProps,
        type: MarketingConsentDetailsIdentifierType.EMAIL,
        shouldSubscribe,
      });
    const onChangePreference = async (id: string, mute: boolean) =>
      setPreference({
        flowAPI,
        setProps: controllerConfig.setProps,
        channel: Channel.EMAIL,
        mute,
        id,
      });

    return {
      async pageReady() {
        controllerConfig.setProps({
          startLoadingTime,
          isSubscribed,
          channelPreferences,
          onChangeSubscription,
          onChangePreference,
          fitToContentHeight: true,
        });
      },
    };
  } else {
    const channelPreferences = await getChannelPreferences({
      flowAPI,
      setProps: controllerConfig.setProps,
      channel: Channel.EMAIL,
    });
    const { isSubscribed } = await getMarketingConsent({
      flowAPI,
      setProps: controllerConfig.setProps,
      type: MarketingConsentDetailsIdentifierType.EMAIL,
    });
    const onChangeSubscription = async (shouldSubscribe: boolean) =>
      setMarketingConsent({
        flowAPI,
        setProps: controllerConfig.setProps,
        type: MarketingConsentDetailsIdentifierType.EMAIL,
        shouldSubscribe,
      });
    const onChangePreference = async (id: string, mute: boolean) =>
      setPreference({
        flowAPI,
        setProps: controllerConfig.setProps,
        channel: Channel.EMAIL,
        mute,
        id,
      });
    return {
      async pageReady() {
        controllerConfig.setProps({
          startLoadingTime,
          isSubscribed,
          channelPreferences,
          onChangeSubscription,
          onChangePreference,
          fitToContentHeight: true,
        });
      },
    };
  }
};

export default createController;
